import axiosClient from './axiosClient'

const companyTitleApi = {
  find: (params) => {
    const url = '/company-title/find'
    return axiosClient.get(url, { params })
  },

  create: (params) => {
    const url = '/company-title/create'
    return axiosClient.post(url, params)
  },

  update: (params) => {
    const url = `/company-title/update/${params.companyTitleId}`
    return axiosClient.put(url, params)
  },

  delete: (params) => {
    const url = '/company-title/delete'
    return axiosClient.delete(url, {
      data: {
        companyTitleIds: params,
      },
    })
  },
}

export default companyTitleApi
